module.exports = __webpack_public_path__ + "static/media/logs.d521d55b.svg";